import { BigNumber } from "@yjsgames/bignumber";
import type { PaymentProvider, PurchaseRequest, StoreProductInfo } from "./paymentPorts.js";

export interface DiamondWallet {
  trySpendDiamond(amount: BigNumber): boolean;
}

/**
 * No-SDK fallback payment provider. It completes purchases by spending in-game
 * diamonds, which is useful for web/dev surfaces where native billing is absent.
 */
export class DiamondPaymentProvider implements PaymentProvider {
  constructor(
    private readonly walletRef: () => DiamondWallet,
    private readonly diamondPriceOf: (productId: string) => number,
  ) {}

  purchase(req: PurchaseRequest): void {
    const price = this.diamondPriceOf(req.productId);
    if (this.walletRef().trySpendDiamond(BigNumber.fromNumber(price))) {
      req.onSuccess({ productId: req.productId, platform: "diamond" });
      return;
    }

    req.onError?.({
      code: "insufficientFunds",
      message: `not enough diamond (need ${price})`,
    });
  }

  getAvailableProducts(_productIds: readonly string[]): Promise<readonly StoreProductInfo[]> {
    return Promise.resolve([]);
  }

  restorePurchases(): Promise<readonly string[]> {
    return Promise.resolve([]);
  }

  isAvailable(): Promise<boolean> {
    return Promise.resolve(true);
  }
}
